<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user?.avatar"
            [src]="user.avatar">
        <mat-icon
            *ngIf="!(showAvatar && user?.avatar)"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
        ></span>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item (click)="_matDialog.open(versionInfoDialog)">
        <span class="flex flex-col leading-none">
            <span>Versiune curenta:</span>
            <span class="mt-1 text-sm font-medium">{{ SMM_VER_DATA.currentVersion.name}}, {{ SMM_VER_DATA.currentVersion.version}}</span>
        </span>
    </button>
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{ 'Signed in as' | transloco }}</span>
            <span class="mt-1.5 text-md font-medium">{{user?.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item
        (click)="goToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ "Profile" | transloco }}</span>
    </button>
<!--    <button mat-menu-item>-->
<!--        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>-->
<!--        <span>{{ "Settings" | transloco }}</span>-->
<!--    </button>-->
<!--    <button-->
<!--        mat-menu-item-->
<!--        [matMenuTriggerFor]="userStatus">-->
<!--        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>-->
<!--        <span>Status</span>-->
<!--    </button>-->
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{ 'Sign out' | transloco }}</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>


<ng-template #versionInfoDialog>
    <div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6">
        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
            <div class="text-lg font-medium">
                {{ SMM_VER_DATA.currentVersion.name}}, {{ SMM_VER_DATA.currentVersion.version}}
            </div>
        </div>

        <!-- Content -->
        <mat-dialog-content class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto min-h-60">
             <div class="flex flex-row gap-2 w-full">
                 <div class="font-bold">Versiune: </div>
                 <div class="">{{SMM_VER_DATA.currentVersion.version}}</div>
             </div>

            <div class="flex flex-row gap-2 w-full">
                <div class="font-bold">Denumire: </div>
                <div class="">{{SMM_VER_DATA.currentVersion.name}}</div>
            </div>

            <div class="flex flex-row gap-2 w-full">
                <div class="font-bold">Sumar: </div>
                <div class="">{{SMM_VER_DATA.currentVersion.summary}}</div>
            </div>

            <div class="flex flex-row gap-2 w-full">
                <div class="font-bold">Data actualizare: </div>
                <div class="">{{SMM_VER_DATA.currentVersion.releaseDate}}</div>
            </div>

            <mat-divider class="my-2"></mat-divider>
            <div class="font-bold text-lg mt-4">Descriere versiune</div>
            <div [innerHTML]="SMM_VER_DATA.currentVersion.descriptionHtmlText"></div>
        </mat-dialog-content>


        <!-- Actions -->
        <div class="flex flex-0 items-center justify-end h-16 px-4">
            <mat-dialog-actions align="end">
                <button mat-button mat-dialog-close>{{ 'ok' | transloco }}</button>
            </mat-dialog-actions>
        </div>
    </div>
</ng-template>
